var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('h2',[_vm._v("404 Not Found")]),_c('p',[_vm._v("找不到這個頁面")])])}]

export { render, staticRenderFns }